import { readBookingPayload } from './readBookingForm';
import { buildFromToISO } from './timeUtils';

export interface BookingExtras {
  floodlight?: boolean;
  [key: string]: unknown;
}

export interface BookingWebhookPayload {
  kind: 'booking';
  name: string;
  email: string;
  phone: string;
  courtKey: string;
  court_id: string;
  start: string;
  duration: string;
  from: string;
  to: string;
  membership?: string;
  extras: BookingExtras;
  floodlight: boolean;
  totalEUR: string;
  timeZone: string;
  player_number: number;
}

/** `extras` arrives as a JSON string the booking form serialized itself, but it still
 *  crosses a parse boundary - narrow it before trusting its shape. */
function parseExtras(raw: string | undefined): BookingExtras {
  if (!raw) return {};
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed !== null && typeof parsed === 'object' ? (parsed as BookingExtras) : {};
  } catch (e) {
    console.warn('Failed to parse extras:', e);
    return {};
  }
}

export function buildBookingPayload(): BookingWebhookPayload {
  const p = readBookingPayload();

  const durationMinutes = parseInt(p.duration, 10);
  const { from, to } = buildFromToISO(p.start, durationMinutes);

  const extrasObj = parseExtras(p.extras);

  return {
    kind: 'booking',
    name: p.name,
    email: p.email,
    phone: p.phone,
    courtKey: p.courtKey,
    court_id: p.courtKey,
    start: p.start,
    duration: p.duration,
    from,
    to,
    membership: p.membership,
    extras: extrasObj,
    floodlight: extrasObj.floodlight || false,
    totalEUR: p.totalEUR,
    timeZone: "Europe/Berlin",
    player_number: p.player_number,
  };
}
